export default __webpack_public_path__ + "static/media/Asset---2.a2d5753a.png";